// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './css/index.css';
import './css/global.css';
import WrappedApp from './App';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GOOGLE_CLIENT_ID } from './config/env';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <WrappedApp />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// Carga asíncrona de reportWebVitals
import('./reportWebVitals').then(({ default: reportWebVitals }) => {
  reportWebVitals();
});
